import { useTranslation } from 'react-i18next';
import { CleanUrl } from "../../../utils/cleanUrl";
// import VotingResults from "./VotingResults";

function ConfirmationPostPromotion() {

    const { t } = useTranslation();
    const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);

    return (
        <>

            <div className="promo-fields-group">
                <div className="promo-fields">

                    <div className="pweu-confirmation-post-promotion-feedback">
                        {/* <div className="pweu-emote">
                            <svg width="144" height="102" viewBox="0 0 144 102" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_3715_13928)">
                                    <path d="M38.3827 33.3195C29.1889 33.714 21.4101 26.587 21.0156 17.3846C20.6211 8.19081 27.748 0.412083 36.9504 0.0175723C46.1443 -0.376939 53.923 6.74999 54.3175 15.9524C54.712 25.1462 47.5851 32.9249 38.3913 33.3195" fill="#FBB517" />
                                    <path d="M107.781 33.3195C98.5873 33.714 90.8086 26.587 90.4141 17.3846C90.0195 8.19081 97.1465 0.412083 106.349 0.0175723C115.543 -0.376939 123.321 6.74999 123.716 15.9524C124.11 25.1462 116.984 32.9249 107.79 33.3195" fill="#FBB517" />
                                    <path d="M0.20347 61.0594L23.6115 43.6166C28.3531 52.7545 35.7642 60.6281 45.4729 65.9375C71.4667 80.1575 104.07 70.6161 118.298 44.6138C118.328 44.555 118.351 44.5048 118.382 44.4461L143.771 58.3449C143.741 58.4036 143.71 58.4542 143.687 58.5126C121.79 98.5323 71.602 113.224 31.5826 91.3348C18.1112 83.9643 7.51154 73.3823 0.211998 61.0673" fill="#FBB517" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_3715_13928">
                                        <rect width="144" height="102" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div> */}
                        <h3>{t("Thank You for your Feedback!")}</h3>
                        <p>{t("We appreciate you taking the time to answer. Your input helps us tailor our promotions and offers to better suit your preferences. Stay tuned for more exciting deals coming your way!")}</p>

                        {/* <VotingResults votingResults={userResponse?.result?.voting} /> */}

                        <a href={window.promotionHome} className="btn btn--secondary btn--center">{t("Return to Homepage")}</a>

                    </div>
                </div>
            </div>


        </>
    );
}

export default ConfirmationPostPromotion;
